// import jQuery from 'CommonScripts/jquery-1.10.2';
(function (window, document, $) {
     
    $(document).ready(function () {            

        //$.components.registerComponent('.inspiration-read-more', function ($root) {
            var $root = document.querySelectorAll('.inspiration-read-more');
                $root = $($root);
                
            var Inspiration = {
                dom: {
                    base: $root,
                    trigger: $root.find('.read-more-title'),
                    content: $root.find('.read-more-content')
                },
                set: {
                    speed: 400,
                    animating: false,
                    heightClosed: 0,
                    heightOpen: 0,
                    newHeight: null,
                    activeClass: 'opened'
                },
                fn: {
                    /* Function for setting heights the first time the block is opened */
                    SetNewExpanderHeights: function () {
                        $set.heightClosed = $dom.content.height();
                        $set.heightOpen = "100%";
                    },
                    InitializeExpander: function () {
                        $dom.base.css('cursor', 'pointer');
                        $dom.trigger.on({
                            click: $fn.ToogleExpander
                        });
                        $dom.base.on({
                            click: $fn.ToogleExpander
                        });
                    },
                    ToogleExpander: function () {
                        if ($set.animating) {
                            return;
                        }

                        var base = $(this).closest('.inspiration-read-more');

                        /* If the height variables are not set, trigger the related function */
                        if ($set.heightOpen === 0) {
                            $fn.SetNewExpanderHeights();
                        }

                        if (base.hasClass($set.activeClass)) {
                            $fn.CloseExpander(base);
                        } else {
                            $fn.OpenExpander(base);
                        }

                      
                    },
                    OpenExpander: function (base) {
                        var content = base.find('.read-more-content');
                        $set.animating = true;
                        $set.newHeight = $set.heightOpen;
                        content.animate({ height: $set.newHeight }, $set.speed, function () {
                            base.toggleClass($set.activeClass);
                            content.toggleClass($set.activeClass);
                            $set.animating = false;
                        });
                        base.css('cursor', 'auto');
                        //Remove the eventhander to click the whole section
                        base.off({
                            click: $fn.ToogleExpander
                        });
                    },
                    CloseExpander: function (base) {
                        var content = base.find('.read-more-content');

                        $set.animating = true;
                        $set.newHeight = $set.heightClosed;
                        base.toggleClass($set.activeClass);
                        content.toggleClass($set.activeClass);
                        content.animate({ height: $set.newHeight }, $set.speed, function () {
                            $set.animating = false;
                        });
                        base.css('cursor', 'pointer');
                        //Add eventhandler to click the whole section
                        base.on({
                            click: $fn.ToogleExpander
                        });
                    }
                }
            },
            /* Add quick access variables to be used in local function
             * Keep main variable name in case it needs to be shared with other JS files
             */
            $dom = Inspiration.dom,
            $set = Inspiration.set,
            $fn = Inspiration.fn;

            /* Run an initializer of the component */
            $fn.InitializeExpander();
        //});

    });

})(window, document, jQuery);